/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: BI Dashboard
 *| (C) Copyright IBM Corp. 2018
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

define([
	'underscore',
	'../../../lib/@waca/upgrades/UpgradeBase',
	'./utils/WidgetUpgradeUtils'
], (_, UpgradeBase, WidgetUpgradeUtils) => {

	const TEXT_WIDGET_TYPE = 'text';

	class TextWidgetResponsiveUpgradeHelper extends UpgradeBase {

		constructor() {
			super();

			this.VERSION = 1022;
		}

		/**
		 * Perform upgrades for TextWidgets that might have been saved in a state where it was both isResponsive
		 *  and had font-sizes set for inner <span> elements
		 *
		 * @param {object} spec - spec to perform upgrade on
		 *
		 * @return {Promise} Promise to be resolved when upgrade performed
		 */
		up(spec) {

			if (!spec) {
				return Promise.resolve(spec);
			}
			if (!WidgetUpgradeUtils.specHasWidgets(spec)) {
				return Promise.resolve(spec);
			}

			return this._upgradeWidgets(spec);

		}

		down(spec) {
			// no downgrade at this time; return as is:
			// we don't save backups of specs
			return Promise.resolve(spec);
		}

		_upgradeWidgets(spec) {
			_.each(spec.widgets, (model) => {
				if(model.type === TEXT_WIDGET_TYPE) {
					this._upgradeTextWidget(model);
				}
			});
			return Promise.resolve(spec);
		}

		_upgradeTextWidget(model) {
			if(!model.content) {
				return;
			}

			const table = model.content.translationTable;
			if(table) {
				for(const lang in table) {
					table[lang] = this._upgradeContent(table[lang], model.isResponsive);
				}
			} else if(typeof model.content === 'string') {
				model.content = this._upgradeContent(model.content, model.isResponsive);
			}
		}


		_upgradeContent(content, isResponsive) {
			if(isResponsive) {
				content = content.replace(/\s*rt_fontSize[0-9]*/gi, '');
				content = content.replace(/\s*font-size\s*:[^;]*;*/gi, '');
			}

			if(content.includes('contenteditable="true"')) {
				content = content.replace(/\s*contenteditable="true"/gi, '');
			}

			if(content.includes('style=""')) {
				content = content.replace(/\s*style=""/gi, '');
			}

			return content;
		}
	}

	return new TextWidgetResponsiveUpgradeHelper();

});
